module.exports = __webpack_public_path__ + "img/LogoTeste.46aa5c8f.jpeg";